import {mock} from './index';

export default {
  // getPublicKey: () => '/encrypt/publicKey',
  getPublicKey: () => '/app-portal/v1/encrypt/publicKey',
  login: () => ('/login'),
  ssoLogin: token => `/app-portal/web/v1/ssologout?token=${token}`,
  getUserOrganizationList: () => '/user/organization/list',
  setUserOrganization: () => '/session/set',
  getSession: () => '/session/get',
  logout: () => '/logout',
  getLionConfiguration: () => '/lion/get',
  loginViaCode: () => '/loginViaCode',
  sendVeritficationCode: () => mock('/verificationcode/send'),
  verifyVerificationCode: () => mock('/verificationcode/verify')
};
